var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('el-date-picker',{staticClass:"lelect-time m-l-8",attrs:{"type":_vm.timeType,"value-format":_vm.format,"range-separator":"-","start-placeholder":"开始日期","end-placeholder":"结束日期"},model:{value:(_vm.Time),callback:function ($$v) {_vm.Time=$$v},expression:"Time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }